import FontLoadingFailedEvent from '@adobe-fonts/site/events/FontLoadingFailedEvent.js';

import { getNotificationService } from './notification_service.ts';
import { getData } from './script_data.js';

const notificationService = getNotificationService();

/**
 * Initialize listener for FontLoadingFailedEvent custom events from
 * adobe-fonts-site's `<af-display-in-font>` component.
 */
export function initFontLoadingFailedListener() {
  window.addEventListener(FontLoadingFailedEvent.EVENT_NAME, function() {
    const i18n = getData('/neue/i18n') || {};
    const message = i18n['frontend.browse_sample_text']?.['font_loading_failed'];
    if (message) {
      notificationService.error(message);
    }
  });
}
